import { Component } from '@angular/core';

@Component({
  selector: 'app-spinner-fullscreen',
  templateUrl: './spinner-fullscreen.component.html',
  styleUrl: './spinner-fullscreen.component.scss'
})
export class SpinnerFullscreenComponent {

}
